<template>
  <div v-if="!isComponentLoading" id="certifications-list">
    <CertificationsList
      v-if="certifications && certifications.length"
      :certifications="certifications"
    />
    <CertificationsListEmpty v-else />
    <VouchersList v-if="vouchers && vouchers.length" :vouchers="vouchers" />
    <ExamScoreModal
      v-if="currentScoredAttempt && currentScoredAttempt.id"
      :attempt="currentScoredAttempt"
      :cert="currentScoredCertification"
      @close-score-modal="closeScoreModal"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CertificationsList from '@/components/user-dashboard/certifications/CertificationsList.vue'
import CertificationsListEmpty from '@/components/user-dashboard/certifications/CertificationsListEmpty.vue'
import VouchersList from '@/components/user-dashboard/certifications/VouchersList.vue'
import ExamScoreModal from '@/components/modals/ExamScoreModal.vue'

export default {
  name: 'Certifications',
  components: {
    CertificationsList,
    CertificationsListEmpty,
    VouchersList,
    ExamScoreModal,
  },
  computed: {
    ...mapState({
      isComponentLoading: state => state.app.isComponentLoading,
      certifications: state => state.certifications.usersCertifications,
      vouchers: state => state.certifications.usersVouchers,
      currentScoredAttempt: state => state.certifications.currentScoredAttempt,
      currentScoredCertification: state =>
        state.certifications.currentScoredCertification,
    }),
  },
  async created() {
    this.$store.dispatch('app/setIsComponentLoading', true)
    await this.$store.dispatch('certifications/getUsersCertifications')
    await this.$store.dispatch('certifications/getUsersVouchers')
    this.$store.dispatch('app/setIsComponentLoading', false)
  },
  methods: {
    closeScoreModal() {
      this.$store.dispatch('certifications/setCurrentAttemptScored', {})
    },
  },
}
</script>
